/*eslint-disable*/
export const sortGroups = ({ groups, sortBy, sortOrder }) =>  [...groups].sort((a, b) => {
    const isAsc = sortOrder === 'asc';
    return isAsc ? a[sortBy].localeCompare(b[sortBy]) : b[sortBy].localeCompare(a[sortBy]);
});